import { useEffect } from "react";

import { useAnalytics, useConfig } from "app/contexts";

import { useUserWithIdentity } from "../auth/useUserWithIdentity";
import { usePageEvent } from "./usePageEvent";

export function useInitAnalytics(
  version: string,
  cloudCustodianVersion: string,
) {
  const analytics = useAnalytics();
  const config = useConfig();
  const user = useUserWithIdentity();

  // Declared before usePageEvent so this effect runs first and Segment sees
  // identify() and group() before the initial page() call.
  useEffect(() => {
    analytics.identify(user.identity?.userId || user.username);
    const customer = config?.customer ?? "Stacklet";
    analytics.group(customer, { name: customer });
  }, [analytics, user, config?.customer]);

  usePageEvent(version, cloudCustodianVersion);
}
